import React from 'react'
import styled, { css } from 'styled-components'

import { BORDER_RADIUS, SIZES, COLORS } from '~/common/globalStyles'

export interface InputElementsProps {
  fullWidth?: boolean
  internalOnly?: boolean
}

export const Label = styled.label<
  InputElementsProps & React.HTMLProps<HTMLLabelElement>
>`
  display: inline-block;
  margin-bottom: ${SIZES.xs};

  ${({ required }) =>
    required &&
    css`
      &:after {
        display: inline;
        content: ' *';
      }
    `};
`

/* shared styled */
const baseInput = css<InputElementsProps>`
  padding: 0 ${SIZES.small};
  font-size: ${SIZES.medium};
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.paper};
  border-width: 1px;
  border-style: solid;
  border-radius: ${BORDER_RADIUS}px;
  outline: none;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `};
  ${({ internalOnly }) =>
    internalOnly &&
    css`
      background: ${COLORS.beige};
    `};
`

const focus = css`
  border-color: ${({ theme }) => theme.palette.current};
  box-shadow: 0 0 0 2px rgba(126, 162, 252, 0.4);
`

export const styles = {
  baseInput,
  focus,
}
